const contactUs = {
    MAIL_ADDRESS: 'mailAddress',
    PHONE_1: 'phone1',
    PHONE_2: 'phone2',
    FAX: 'fax',
    EMAIL: 'email',
};

export default contactUs;
